<template>
  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 22 22">
    <title>Aggiungi</title>
    <path
      d="M14.93,9.739h-2.753v-2.753c0-.65-.527-1.177-1.177-1.177s-1.177.527-1.177,1.177v2.753h-2.753c-.65,0-1.177.527-1.177,1.177s.527,1.177,1.177,1.177h2.753v2.753c0,.65.527,1.177,1.177,1.177s1.177-.527,1.177-1.177v-2.753h2.753c.65,0,1.177-.527,1.177-1.177s-.527-1.177-1.177-1.177Z"
      fill="currentColor"
    />
    <path
      d="M18.07,3.93c-1.808-1.81-4.31-2.93-7.07-2.93s-5.262,1.12-7.07,2.93c-1.81,1.81-2.93,4.31-2.93,7.07s1.12,5.262,2.93,7.07c1.808,1.81,4.31,2.93,7.07,2.93s5.26-1.12,7.07-2.93c1.81-1.808,2.93-4.31,2.93-7.07s-1.12-5.26-2.93-7.07ZM16.898,16.898c-1.509,1.509-3.592,2.443-5.897,2.443s-4.39-.934-5.898-2.443c-1.509-1.51-2.443-3.595-2.443-5.898s.933-4.388,2.443-5.897c1.509-1.509,3.594-2.443,5.897-2.443s4.388.933,5.897,2.441,2.443,3.595,2.445,5.898c0,2.305-.934,4.39-2.443,5.898Z"
      fill="currentColor"
    />
  </svg>
</template>

<script>
export default {};
</script>
